<template>
  <Layout class="md:bg-s-50">
    <div class="max-w-[1196px] mx-auto w-full px-4.5 lg:px-10 xl:px-0">
      <AccountHeader :key="fullPath" />

      <div>
        <slot />
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
/** components */
import AccountHeader from '~/components/account/Header.vue'
import Layout from '~/components/TheLayout.vue'

/** app */
const $route = useRoute()

/** computed */
const fullPath = computed(() => $route.fullPath)
</script>
